import React from 'react';

import { NotaProdutoDetailComp } from './components';

import { ListagemProvider } from 'context/ListagemContext';

export function NotaProdutoDetail() {
    return (
        <ListagemProvider>
            <NotaProdutoDetailComp />
        </ListagemProvider>
    );
}
